<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->

          <!-- Search -->
          <b-col cols="12" lg="8">
            <b-row class="align-items-center">
              <b-col lg="6" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    @keyup.enter="onSearch()"
                    v-model.trim="searchQuery"
                    class="d-inline-block round"
                    :placeholder="$t('nameDescription')"
                  />
                </div>
              </b-col>
              <b-col
                cols="12"
                md="4"
                lg="4"
                class="d-flex align-items-center justify-content-center justify-content-lg-start p-0 my-1 m-lg-0"
              >
                <b-button
                  class="round px-5"
                  variant="primary"
                  :disabled="searchQuery ? false : true"
                  @click="onSearch"
                >
                  {{ $t("search") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <!-- <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" class="round" @click="New()">
              {{ $t("addPermission") }}
            </b-button>
          </b-col> -->
        </b-row>
      </div>
      <b-table responsive="sm" :items="items" :fields="fields">
        <template #cell(name)="row">
          {{ row.value.first }} {{ row.value.last }}
        </template>
        <template #cell(actions)="row">
          <b-button
            variant="primary"
            v-b-tooltip.hover.top="'Permission'"
            size="sm"
            @click="Permission(row.item, row.index, $event.target)"
          >
            <feather-icon icon="UserCheckIcon" />
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            v-b-tooltip.hover.top="'Update Role'"
            @click="Edit(row.item, row.index, $event.target)"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
          <!-- <b-button
            variant="danger"
            size="sm"
            v-b-tooltip.hover.top="'Delete Permission'"
            @click="Delete(row.item, row.index, $event.target)"
          >
            <feather-icon icon="DeleteIcon" />
          </b-button> -->
        </template>
      </b-table>
      <b-row class="pl-2 pr-2 pb-1 pt-1 border-top">
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t("showing") }}</label>

          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            style="min-width: 60px"
            class="per-page-selector select-size-sm d-inline-block ml-50 mr-1"
          />
          <label>{{ $t("entries") }}</label>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      id="modal-edit"
      no-close-on-backdrop
      :title="modal_title"
      @ok="handleOk"
    >
      <validation-observer ref="simpleRules">
        <b-row>
          <b-col cols="6">
            <validation-provider
              name="ID"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>{{ $t("id") }}<span class="required">*</span> </label>

                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.ID"
                  :placeholder="$t('enterID')"
                />
                <small v-show="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider
              name="name"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label>{{ $t("name") }}<span class="required">*</span> </label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="currentItem.ROLE_NAME"
                  :placeholder="$t('enterName')"
                />
                <small v-show="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group :label="$t('description')">
              <b-form-input
                v-model="currentItem.DESCRIPTION"
                :placeholder="$t('enterDescription')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-edit')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handleOk"
          class="btn round"
        >
          {{ modal_title == "Update Permission" ? $t("update") : $t("add") }}
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-permission"
      size="lg"
      scrollable
      body-class="p-0"
      :title="$t('permission')"
      @ok="handPermission"
    >
      <b-table responsive="sm" hover :items="permisItems" :fields="perFields">
        <template #cell(name)="row">
          {{ row.value.first }} {{ row.value.last }}
        </template>
        <template #cell(C)="row">
          <b-form-checkbox v-model="row.item.C" />
        </template>
        <template #cell(WR1_MENU)="row">
          <b-form-checkbox disabled v-model="row.item.WR1_MENU" />
        </template>
      </b-table>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-permission')"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handPermission"
          class="btn round"
        >
          {{ $t("update") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

import vSelect from "vue-select";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  mounted() {
    this.fetchGroup();
  },
  watch: {
    perPage: function (n, o) {
      this.fetchGroup();
    },
    searchQuery: function (n, o) {
      if (this.searchQuery == "") this.fetchGroup();
    },
    currentPage: function (n, o) {
      this.fetchGroup();
    },
    "$i18n.locale": function (newVal, oldVal) {
      this.renderComponent = false;
      this.fields = [];
      this.$nextTick(() => {
        // Add the component back in
        this.fields = [
          {
            key: "ID",
            sortable: false,
            label: "ID",
          },
          {
            key: "ROLE_NAME",
            sortable: false,
            label: "Name",
            label: this.$i18n.t("name"),
          },
          {
            key: "DESCRIPTION",
            label: this.$i18n.t("description"),
            sortable: false,
          },
          {
            key: "actions",
            label: this.$i18n.t("actions"),
            thClass: "text-center",
            tdClass: "actions-td",
          },
        ];

        this.renderComponent = true;
      });
    },
  },
  methods: {
    onSearch() {
      if (this.searchQuery) {
        this.$loading.show();
        this.fetchGroup();
      }
    },
    fetchPermission: function () {
      this.permisItems = [];
      useJwt
        .get(`groupPermission/${this.currentItem.ID}`, {})
        .then((response) => {
          this.permisItems = response.data.result;
          this.permisItems.forEach(function (i, v) {
            i.C = i.C == 1 ? true : false;
            i.R = i.R == 1 ? true : false;
            i.U = i.U == 1 ? true : false;
            i.D = i.D == 1 ? true : false;
            i.WR1_MENU = i.WR1_MENU == 1 ? true : false;
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title:
                "Lỗi lấy danh sách quyền theo nhóm " +
                this.currentItem.ROLE_NAME,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    fetchGroup: function () {
      useJwt
        .get("group", {
          params: {
            search: this.searchQuery,
            page: this.currentPage,
            pageSize: this.perPage,
          },
        })
        .then((response) => {
          this.items = response.data.result;
          this.totalRows = response.data.meta.total;
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    Permission(item, index, button) {
      this.currentItem = item;
      this.fetchPermission();
      this.$bvModal.show("modal-permission");
    },
    Edit(item, index, button) {
      this.currentItem = item;
      this.modal_title = this.$i18n.t("updatePermission");
      this.$bvModal.show("modal-edit");
    },
    New() {
      this.currentItem = {};
      this.modal_title = this.$i18n.t("addPermission");
      this.$bvModal.show("modal-edit");
    },
    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm(
        this.$i18n.t("areYouDeleteitem") + item.ROLE_NAME,
        { title: this.$i18n.t("deleteRow"), size: "sm" }
      );
      if (res) {
        useJwt
          .delete(`group/${this.currentItem.ID}`, {})
          .then((response) => {
            this.fetchGroup();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Delete success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Delete fail",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      }
    },
    handPermission(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.permisItems.forEach(function (i, v) {
        i.C = i.C == null ? false : i.C;
        i.R = i.R == null ? false : i.R;
        i.U = i.U == null ? false : i.U;
        i.D = i.D == null ? false : i.D;
      });
      useJwt
        .put(`groupPermission/${this.currentItem.ID}`, {
          p: this.permisItems.filter((i) => i.C || i.R || i.U || i.D),
        })
        .then((response) => {
          this.$bvModal.hide("modal-permission");
          // this.fetchPermission();

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Update success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          window.location.reload();
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Update fail",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRules.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check the input data!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      if (this.modal_title == "Add Permission") {
        useJwt
          .post("group", {
            id: this.currentItem.ID,
            name: this.currentItem.ROLE_NAME,
            description: this.currentItem.DESCRIPTION || null,
          })
          .then((response) => {
            this.fetchGroup();
            this.$bvModal.hide("modal-edit");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Insert success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Fail insert",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      } else {
        useJwt
          .put(`group/${this.currentItem.ID}`, {
            id: this.currentItem.ID,
            name: this.currentItem.ROLE_NAME,
            description: this.currentItem.DESCRIPTION,
          })
          .then((response) => {
            this.$bvModal.hide("modal-edit");

            this.fetchGroup();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Update success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Fail success",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      }
    },
  },
  data() {
    return {
      items: [],
      permisItems: [],
      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      totalRows: 0,
      currentPage: 1,

      searchQuery: "",
      currentItem: {},
      modal_title: "Add Permission",
      fields: [
        {
          key: "ID",
          sortable: false,
          label: "ID",
        },
        {
          key: "ROLE_NAME",
          sortable: false,
          label: "Name",
          label: this.$i18n.t("name"),
        },
        {
          key: "DESCRIPTION",
          label: this.$i18n.t("description"),
          sortable: false,
        },
        {
          key: "actions",
          label: this.$i18n.t("actions"),
          thClass: "text-center",
          tdClass: "actions-td",
        },
      ],
      perFields: [
        {
          key: "FUNCTION_NAME",
          sortable: false,
          label: this.$i18n.t("function"),
        },
        {
          key: "WR1_MENU",
          sortable: true,
          label: "WR1_MENU",
        },
        {
          key: "C",
          sortable: true,
          label: "#",
        },
      ],
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
